import React from 'react';
import { FiStar } from 'react-icons/fi';

const RatingStars = ({ rating, size = 3 }) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex">
      {[...Array(fullStars)].map((_, i) => (
        <FiStar
          key={`full-${i}`}
          className={`w-${size} h-${size} text-yellow-500 fill-yellow-500`}
        />
      ))}
      {hasHalfStar && (
        <div className="relative">
          <FiStar
            className={`w-${size} h-${size} text-gray-300`}
          />
          <FiStar
            className={`w-${size} h-${size} text-yellow-500 fill-yellow-500 absolute top-0 left-0 overflow-hidden`}
            style={{ width: '50%' }}
          />
        </div>
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <FiStar
          key={`empty-${i}`}
          className={`w-${size} h-${size} text-gray-300`}
        />
      ))}
    </div>
  );
};

export default RatingStars;